// SiteUp: agentes e portais mudam pouco e ficam no store entre telas. A tela
// de conversas refazia GET /agents e GET /portals a cada montagem (sair para
// Contatos e voltar). Agora busca só o que ainda não veio; a presença dos
// agentes segue chegando pelo websocket e as telas de configuração recarregam
// as próprias listas.
export const fetchConversationLookups = store => {
  if (!store.getters['agents/getAgents']?.length) {
    store.dispatch('agents/get');
  }
  if (!store.getters['portals/allPortals']?.length) {
    store.dispatch('portals/index');
  }
};
